module.exports = (__parcel__import__("./" + "protectedFunctions.bac340c1.js")).then(() => parcelRequire('7XiTw'));